module.exports = __webpack_public_path__ + "static/img/icon-takeout-three.cb87562d.png";